import { render } from "./brand-list-modal.vue?vue&type=template&id=787a2be6"
import script from "./brand-list-modal.vue?vue&type=script&lang=js"
export * from "./brand-list-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__